export var VirtualDocName = /*#__PURE__*/function (VirtualDocName) {
  VirtualDocName["NoContextHelpAvailable"] = "virtual:NoContextHelpAvailable";
  return VirtualDocName;
}(VirtualDocName || {});
export const VirtualDocContents = {
  [VirtualDocName.NoContextHelpAvailable]: `
	<h1>Info</h1>
	<p>
		Für diese Seite steht noch keine Kontexthilfe zur Verfügung.<br/>
		Gib gerne Bescheid, wenn du dir Dokumentation zu einer bestimmten Seite wünschst! :)
	</p>
	`
};